import React from "react"
import classnames from "classnames"

import CartIcon from "../assets/icons/cart.svg"
import Button, { ButtonIcon } from "./button"
import { Link } from "gatsby"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import { useSelector } from "react-redux"
import { cartSelectors } from "../store/cartSlice"

const headerLinks = [
  {
    title: "Home",
    url: "/#home",
  },
  {
    title: "Distributors",
    url: "/distributors",
  },
  {
    title: "Products",
    url: "/#products",
  },
  {
    title: "FAQ",
    url: "/#faq",
  },
  {
    title: "Contact Us",
    url: "/#contact",
  },
]

export default function Header() {
  const { title } = useSiteMetadata()
  const numCartItems = useSelector(cartSelectors.numItems)

  return (
    <header className="sticky top-0 left-0 right-0 w-full bg-white shadow-header py-3 z-40">
      <div className="container container-centered w-full flex items-center justify-between">
        <Link to="/">
          <img alt={title} src={require("../assets/images/logo.png")} />
        </Link>
        <nav className="hidden md:block">
          <ul className="list-none flex items-center">
            {headerLinks.map(({ title, url }, index) => (
              <li
                key={url}
                className={classnames(
                  index < headerLinks.length - 1 && "mr-4 lg:mr-18",
                  index === headerLinks.length - 1 && "mr-6.25"
                )}
              >
                <Link
                  to={url}
                  className="text-black font-body text-base lg:text-heading-20"
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <Button to="/cart">
          <ButtonIcon icon={CartIcon} />
          Cart
          {numCartItems > 0 && `(${numCartItems})`}
        </Button>
      </div>
    </header>
  )
}
